import AppVersionReducer from './reducers';

export { default as AppVersionSelectors } from './selectors';

export default AppVersionReducer;
